// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2nkkh","content":"LayoutSettings_content__OrPR7"};